import React, { useEffect, useMemo, useRef, useState } from 'react';
import styles from './Articles.module.scss';
import Toolbar from './Toolbar/Toolbar';
import NewsListArticleList from './List/NewsListArticleList';
import Pagination from './Pagination/Pagination';
import useWindowSize from '../../../../../hooks/useWindowSize';

export default function NewsList({ fields }) {
  const { width } = useWindowSize();
  const isDesktop = width >= 834;
  const itemsPerPage = isDesktop ? 12 : 8;

  const [currentPage, setCurrentPage] = useState(1);
  const [selectedCategory, setSelectedCategory] = useState('All news');

  const categoriesOptions = useMemo(() => {
    const uniqueCategories = Array.from(
      new Set((fields.item || []).map((a) => a.fields.detail.fields.category.value))
    );
    const categories = ['All news', ...uniqueCategories];
    return categories.map((cat) => ({ label: cat, value: cat }));
  }, [fields.item]);

  const filteredArticles = useMemo(() => {
    if (!fields.item) return [];
    if (selectedCategory === 'All news') return fields.item;
    return fields.item.filter(
      (article) => article.fields.detail.fields.category.value === selectedCategory
    );
  }, [fields.item, selectedCategory]);

  const totalPages = Math.ceil(filteredArticles.length / itemsPerPage) || 1;
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const currentPageArticles = filteredArticles.slice(startIndex, endIndex);

  const handleCategoryChange = (option) => {
    setSelectedCategory(option.value);
    setCurrentPage(1);
  };

  const listRef = useRef(null);
  const [hasMounted, setHasMounted] = useState(false);
  const [isPageChanged, setIsPageChanged] = useState(false);

  useEffect(() => setHasMounted(true), []);
  useEffect(() => {
    if (hasMounted && isPageChanged && listRef.current) {
      listRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    setIsPageChanged(false);
  }, [currentPage, hasMounted, isPageChanged]);

  const handlePageChange = (value) => {
    setCurrentPage(value);
    setIsPageChanged(true);
  };
  return (
    <div className={'container'}>
      <div className={styles.wrapper}>
        {/* <Toolbar options={categoriesOptions} onSelect={handleCategoryChange} /> */}
        <NewsListArticleList ref={listRef} articles={currentPageArticles} />
        <div className={styles.pagination} data-aos="fade-up">
          <Pagination
            totalPages={totalPages}
            currentPage={currentPage}
            onPageChange={handlePageChange}
            fields={fields}
          />
        </div>
      </div>
    </div>
  );
}
